import { render, staticRenderFns } from "./advertisingPlatform.vue?vue&type=template&id=ed28e5c0&scoped=true&"
import script from "./advertisingPlatform.vue?vue&type=script&lang=js&"
export * from "./advertisingPlatform.vue?vue&type=script&lang=js&"
import style0 from "./advertisingPlatform.vue?vue&type=style&index=0&id=ed28e5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed28e5c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed28e5c0')) {
      api.createRecord('ed28e5c0', component.options)
    } else {
      api.reload('ed28e5c0', component.options)
    }
    module.hot.accept("./advertisingPlatform.vue?vue&type=template&id=ed28e5c0&scoped=true&", function () {
      api.rerender('ed28e5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/advertisingPlatform.vue"
export default component.exports